import React from 'react'
import ModalContext from 'components/Context/ModalContext'
import YourClass from './YourClass'
import gql from 'graphql-tag'
import DataContainer from 'components/DataContainer/DataContainer'
import MediaQuery from 'components/MediaQuery/MediaQuery'

const queries = [
  {
    query: gql`
      {
        me {
          _id
          name
          parent
          google {
            id
            email
            hasRefreshToken
          }
          group {
            _id
            name
            yearGroup
            google {
              id
            }
            students(limit: 0, skip: 0) {
              users {
                _id
                google {
                  id
                  email
                }
                demo
                username
                name
                yearGroup
                parentEmail
              }
            }
          }
          archivedGroups {
            _id
            name
            yearGroup
            createdAt
            students(limit: 0, skip: 0) {
              count
            }
          }
        }
      }
    `,
    props: ({ data }) => {
      if (data.loading || data.error) {
        return { loading: data.loading, error: data.error }
      }
      const group = (data.me && data.me.group) || {}
      return {
        loggedInUser: {
          _id: data.me && data.me._id,
          name: data.me && data.me.name,
          isGoogle: data.me && data.me.google && data.me.google.email && true,
          googleEmail: data.me && data.me.google && data.me.google.email,
          hasRefreshToken: data.me && data.me.google && data.me.google.hasRefreshToken && true
        },
        isGoogleGroup: data.me && data.me.group && data.me.group.google && data.me.group.google.id && true,
        isParent: data.me && data.me.parent,
        groupName: group.name,
        groupId: group._id,
        courseId: group.google && group.google.id,
        yearGroup: group.yearGroup,
        students: group.students && group.students.users,
        archivedGroups: data.me && data.me.archivedGroups
      }
    },
    options: {
      fetchPolicy: 'network-only'
    }
  }
]

const mutations = [
  {
    mutation: gql`
      mutation updateUsers($users: [UserInput]) {
        updateUsers(users: $users) {
          _id
        }
      }
    `,
    props: ({ mutate }) => ({
      updateStudentDetails: async details => {
        try {
          await mutate({
            variables: {
              users: details
            }
          })
        } catch (e) {
          console.error(e)
        }
      }
    })
  },
  {
    mutation: gql`
      mutation registerStudents($students: [StudentInput]!, $teacherId: String!) {
        registerStudents(students: $students, teacherId: $teacherId)
      }
    `,
    props: ({ mutate }) => ({
      addStudents: async (students, teacherId) => {
        await mutate({
          variables: {
            students,
            teacherId
          }
        })
      }
    })
  },
  {
    mutation: gql`
      mutation removeStudent($userId: String!, $teacherPassword: String!) {
        removeStudent(userId: $userId, teacherPassword: $teacherPassword)
      }
    `,
    props: ({ mutate }) => ({
      deleteStudent: async (studentId, teacherPassword) => {
        await mutate({
          variables: {
            userId: studentId,
            teacherPassword
          }
        })
      }
    })
  },
  {
    mutation: gql`
      mutation registerGroup($group: GroupInput!, $teacherId: String!) {
        registerGroup(group: $group, teacherId: $teacherId) {
          _id
        }
      }
    `,
    props: ({ mutate }) => ({
      registerGroup: async (group, teacherId) => {
        await mutate({
          variables: {
            group,
            teacherId
          }
        })
      }
    })
  },
  {
    mutation: gql`
      mutation changeActiveGroup($groupId: String) {
        changeActiveGroup(groupId: $groupId) {
          _id
        }
      }
    `,
    props: ({ mutate }) => ({
      changeActiveGroup: async (groupId) => {
        await mutate({
          variables: {
            groupId
          }
        })
      }
    })
  },
  {
    mutation: gql`
      mutation syncAccountWithGoogle($code: String) {
        syncAccountWithGoogle(code: $code) {
          _id
          google {
            id
            email
          }
        }
      }
    `,
    props: ({ mutate }) => ({
      syncAccountWithGoogle: code => mutate({
        variables: {
          code
        }
      })
    })
  }
]

class YourClassContainer extends React.Component {
  render () {
    return (
      <ModalContext.Consumer>
        {modal => (
          <MediaQuery>
            <YourClass {...this.props} modal={modal} />
          </MediaQuery>
        )}
      </ModalContext.Consumer>
    )
  }
}

export default props => (
  <DataContainer queries={queries} mutations={mutations}>
    <YourClassContainer {...props} />
  </DataContainer>
)
